<template>
  <div id="home-page" class="travel-page">
    <correlation-map></correlation-map>
    
    
  </div>
</template>

<script>
import CorrelationMap from "./../components/CorrelationMap.vue"
import _ from "lodash"

export default {
  name: "HomePage",
  components: {
    CorrelationMap
  },
  props: {
  },
  created() {
  },

  data: () => ({
  }),
  
  watch: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
